var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('PcsLogo',{staticClass:"mt-5",attrs:{"height":"90"}}),_c('ResHubLogo',{attrs:{"height":90,"aspectRatio":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }